import React, { useContext, useState } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { useChat } from '../contexts/ChatContext';
import Feed from './Feed';
import RightSidebar from '../components/RightSidebar';
import FloatingChat from '../components/FloatingChat';
import './Home.css';

const Home = () => {
  const { user, loading } = useContext(AuthContext);
  const { conversations, onlineUsers } = useChat();
  const [floatingChatUser, setFloatingChatUser] = useState(null);

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <div className="home-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // Show landing page for unauthenticated users
  if (!user) {
    return (
      <div className="home-container">
        <div className="home-hero">
          <div className="hero-content">
            <h1>Connect with friends & family</h1>
            <p className="hero-subtitle">
              Share moments, chat instantly, stay close with the people who matter most.
            </p>
            <a href="/login" className="get-started-btn">
              Get Started
            </a>
          </div>
        </div>
      </div>
    );
  }

  // Get online users from conversations who are online
  const onlineFriends = conversations
    .filter(conv => conv.other_user && onlineUsers.has(conv.other_user.id))
    .map(conv => conv.other_user);

  const handleOpenChat = async (userToChat) => {
    // Open floating chat with this user
    setFloatingChatUser(userToChat);
  };

  const handleCloseFloatingChat = () => {
    setFloatingChatUser(null);
  };

  // Show feed for authenticated users
  return (
    <div className="home-page">
      <div className="home-content">
        <Feed />
        <RightSidebar
          onlineUsers={onlineFriends}
          onOpenChat={handleOpenChat}
        />
      </div>
      {floatingChatUser && (
        <FloatingChat
          user={floatingChatUser}
          onClose={handleCloseFloatingChat}
        />
      )}
    </div>
  );
};

export default Home;
